var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button, TextBox, useModal } from "@animech/ui";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingModal } from "../../loading-modal/loading-modal";
import * as Styled from "./share-system-modal.style";
import { actions, useAppDispatch } from "store";
import { CustomBaseModal } from "ui/components/modals/custom-base-modal/custom-base-modal";
import { getClaimSystemLink } from "utility/share";
import { TimedNotification } from "ui/components/elements/timed-notification";
export var ShareSystemModal = function (_a) {
    var props = __rest(_a, []);
    var _b = __read(useState(false), 2), showShareNotification = _b[0], setShowShareNotification = _b[1];
    var _c = __read(useState(false), 2), showEmailSentNotification = _c[0], setShowEmailSentNotification = _c[1];
    var _d = __read(useState(null), 2), warningMessage = _d[0], setWarningMessage = _d[1];
    var _e = __read(useState(""), 2), email = _e[0], setEmail = _e[1];
    var system = props.system;
    var t = useTranslation().t;
    var openModal = useModal();
    var dispatch = useAppDispatch();
    var _f = __read(useState(), 2), claimLink = _f[0], setClaimLink = _f[1];
    var loadClaimableSystem = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var loadingModal, claimId, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingModal = openModal(_jsx(LoadingModal, { translationKey: "share_system_modal.loading" }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(actions.shareSystem({
                            id: system.id,
                        })).unwrap()];
                case 2:
                    claimId = (_a.sent()).claimId;
                    setClaimLink(getClaimSystemLink(claimId));
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setWarningMessage(t("share_system_modal.share_system_error"));
                    return [3 /*break*/, 4];
                case 4:
                    loadingModal.close();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, openModal, system.id, t]);
    var onSendEmail = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var loadingModal, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!claimLink) {
                        return [2 /*return*/];
                    }
                    loadingModal = openModal(_jsx(LoadingModal, { translationKey: "share_system_modal.sending" }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(actions.sendEmail({
                            toEmail: email.trim(),
                            subject: t("share_system_modal.email_subject"),
                            message: claimLink,
                        })).unwrap()];
                case 2:
                    _a.sent();
                    setShowEmailSentNotification(true);
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    setWarningMessage(t("share_system_modal.send_email_error"));
                    return [3 /*break*/, 4];
                case 4:
                    loadingModal.close();
                    return [2 /*return*/];
            }
        });
    }); }, [claimLink, dispatch, email, openModal, t]);
    useEffect(function () {
        loadClaimableSystem();
    }, [loadClaimableSystem]);
    var onCopyLink = function () {
        if (!claimLink)
            return;
        navigator.clipboard.writeText(claimLink);
        setShowShareNotification(true);
    };
    return (_jsxs(CustomBaseModal, __assign({ title: t("share_system_modal.title"), color: "inverted", hideCloseButton: false }, props, { children: [claimLink && (_jsxs(Styled.Container, { children: [_jsx(Styled.CopyLinkButton, { appearance: "inverted", onClick: onCopyLink, icon: "copy", children: t("share_system_modal.share_button") }), _jsx(Styled.Divider, { children: t("share_system_modal.email_description") }), _jsx(TextBox, { label: t("share_system_modal.email"), instantValueChange: true, value: email, onValueChange: setEmail }), _jsx(Styled.LinkContainer, { children: _jsx(Button, { disabled: email.length === 0, onClick: onSendEmail, children: t("share_system_modal.send_email") }) })] })), showShareNotification && (_jsx(TimedNotification, { text: t("notifications.link_copied"), timeout: 3000, color: "success", onClose: function () { return setShowShareNotification(false); } })), showEmailSentNotification && (_jsx(TimedNotification, { text: t("share_system_modal.email_sent"), timeout: 5000, color: "success", onClose: function () { return setShowEmailSentNotification(false); } })), warningMessage !== null && (_jsx(TimedNotification, { text: warningMessage, timeout: 10000, color: "alert", onClose: function () { return setWarningMessage(null); } }))] })));
};
